import _asyncToGenerator from "D:/wwwroot/dealer-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "regenerator-runtime/runtime.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { listBrand } from '@/api/brand.js';
import { listStockMain } from '@/api/stock.js';
export default {
  components: {},
  data: function data() {
    return {
      drawerTitle: '添加产品',
      drawerVisible: false,
      searchForm: {
        barCode: null,
        productNumber: null,
        productName: null,
        batch_number: null,
        trackingCode: null,
        specificationModel: null,
        brandId: null,
        isVirtualWarehouse: 2,
        manufacturerId4: null,
        page: 1,
        pageSize: 10,
        total: 0
      },
      brandList: [],
      brandLoading: false,
      dataList: [],
      dataLoading: false,
      searchFormExpand: false
    };
  },
  methods: {
    init: function init(_ref) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var distributorId, barCode, batchNumber, trackingCode, that;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                distributorId = _ref.distributorId, barCode = _ref.barCode, batchNumber = _ref.batchNumber, trackingCode = _ref.trackingCode;
                that = _this;
                that.drawerVisible = true;
                that.searchForm.manufacturerId4 = distributorId;
                that.searchForm.barCode = barCode;
                that.searchForm.batch_number = batchNumber;
                that.searchForm.trackingCode = trackingCode;
                that.searchForm.page = 1;
                that.dataList = [];
                _context.next = 11;
                return that.loadBrand();

              case 11:
                _context.next = 13;
                return that.loadData();

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    drawerClose: function drawerClose() {
      var that = this;
      that.$nextTick(function () {
        that.drawerVisible = false;
      });
    },
    loadData: function loadData() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var that, query;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                that = _this2;
                query = JSON.parse(JSON.stringify(that.searchForm));
                that.dataLoading = true;
                that.dataList = [];
                _context2.next = 6;
                return listStockMain(query).then(function (res) {
                  res.list.map(function (row) {
                    row.specs = row.specs ? row.specs : {};
                    that.dataList.push({
                      ID: null,
                      specsId: row.specs_id,
                      mainId: row.main_id,
                      deliveryQuantity: 0,
                      hospitalUnitPrice: 0,
                      hospitalAmount: 0,
                      remarks: null,
                      productName: row.main.productName,
                      brandName: row.main.brandName,
                      batchNumber: row.batch_number,
                      registrationNumber: row.main.registrationNumber,
                      manufacturer: row.main.manufacturer,
                      inventoryId: row.ID,
                      normalQuantity: row.normalQuantity,
                      stockQuantity: row.stock_quantity,
                      trackingCode: row.trackingCode,
                      productNumber: row.specs.productNumber || null,
                      barCode: row.specs.barCode || null,
                      specificationModel: row.specs.specificationModel || null,
                      unit: row.specs.unit || null,
                      wholesalePurchasePrice: row.specs.wholesalePurchasePrice || 0,
                      consignmentPurchasePrice: row.specs.consignmentPurchasePrice || 0,
                      marketPrice: row.specs.marketPrice || 0,
                      consignmentPrice: row.specs.consignmentPrice || 0,
                      wholesalePrice: row.specs.wholesalePrice || 0,
                      onlPrice: row.specs.onlPrice || 0,
                      lowPrice: row.specs.lowPrice || 0,
                      salesUnitPrice: row.afterTaxPrice,
                      salesAmount: row.afterTaxPrice * row.deliveryQuantity,
                      checked: false,
                      genericName: row.specs.genericName
                    });
                  });
                  that.searchForm.total = res.total;
                }).catch(function (e) {
                  console.log(e);
                });

              case 6:
                that.dataLoading = false;

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    loadBrand: function loadBrand() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var that, query;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                that = _this3;
                that.brandList = [];
                that.brandLoading = true;
                query = {
                  page: 1,
                  pageSize: 9999
                };
                _context3.next = 6;
                return listBrand(query).then(function (res) {
                  that.brandList = res.list;
                }).catch(function (e) {});

              case 6:
                that.brandLoading = false;

              case 7:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    searchFormSubmit: function searchFormSubmit() {
      var that = this;
      that.searchForm.page = 1;
      that.searchForm.total = 0;
      that.loadData();
    },
    formSubmit: function formSubmit() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var that, rows, findRow;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                that = _this4;
                rows = that.$refs.productTableRef.selection;

                if (rows.length === 0) {
                  that.$message.error('请选择产品');
                }

                rows.map(function (item) {
                  item.hospitalUnitPrice = Number(item.hospitalUnitPrice);
                  item.hospitalSumPrice = Number(Number(item.hospitalUnitPrice) * Number(item.deliveryQuantity)).toFixed(2);
                  item.hospitalSumPrice = Number(item.hospitalSumPrice);
                });
                findRow = rows.find(function (item) {
                  return item.deliveryQuantity === 0;
                });

                if (!findRow) {
                  _context4.next = 9;
                  break;
                }

                that.$message.error('产品：' + findRow.productName + ' 规格型号：' + findRow.specificationModel + '，未设置采购数量');
                that.$refs.productTableRef.setCurrentRow(findRow, true);
                return _context4.abrupt("return");

              case 9:
                that.$emit('add', rows);

              case 10:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    pageChange: function pageChange(page) {
      var that = this;
      that.searchForm.page = page;
      that.loadData();
    },
    sizeChange: function sizeChange(pageSize) {
      var that = this;
      that.searchForm.pageSize = pageSize;
      that.searchForm.page = 1;
      that.loadData();
    },
    rowClick: function rowClick(row) {
      var that = this;
      that.$refs.productTableRef.toggleRowSelection(row); // 判断该行记录，是选中还是未选中

      var rows = that.$refs.productTableRef.selection;

      if (rows.includes(row)) {
        if (row.deliveryQuantity < 1) {
          row.deliveryQuantity = 1;
        }
      }
    },
    rowClassName: function rowClassName(_ref2) {
      var row = _ref2.row;
      var that = this;
      var rows = that.$refs.productTableRef.selection;

      if (rows.includes(row)) {
        row.checked = true;
      } else {
        row.checked = false;
      }
    },
    selectionChange: function selectionChange(selection) {
      selection.map(function (item) {
        item.deliveryQuantity = item.deliveryQuantity || 1;
      });
    }
  }
};